<template>
  <div class="content">
    <h1>{{time}}政府公共服务类</h1>
    <div class="charts" id="chart"></div>
  </div>
</template>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
 html,body,.content,.charts {
   width: 100%;
   height: 100%;
 }
 .charts {
   padding-top: 80px;
    height: 900px;
 }
 h1 {
   width: 100%;
   color: #0034E4;
   text-align: center;
   font-size: 40px;
   position: absolute;
   top: 0;
   left: 0;
   line-height: 100px;
 }
</style>

<script>
export default {
  mounted () {
    this.chart()
  },
  computed: {
    time: function () {
      var myDate = new Date()
      let month = Number(myDate.getMonth()) + 1
      return myDate.getFullYear() + '年' + month + '月' + myDate.getDate() + '日'
    }
  },
  methods: {
    chart () {
      var myChart = this.$echarts.init(document.getElementById('chart'))
      // 绘制图表
      myChart.setOption({
        title: {
          // text: '2018年9月20日政府公共服务类'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // data: ['业务量']
        },
        toolbox: {
          show: true,
          feature: {
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: ['家政保洁', '疏通下水道', '清洗炉盘', '厨房保洁', '开荒保洁', '灯管更换', '家庭搬家', '家庭陪护', '医院陪护', '小孩托管', '住家保姆', '育婴师', '石材翻新', '房屋粉刷', '保洁清洗', '物业托管', '钟点工']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            // name: '业务量',
            type: 'bar',
            data: [22, 24, 17, 23, 25, 16, 35, 42, 32, 20, 26, 13, 32, 42, 22, 12, 22],
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'}
              ]
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 首先定义一个数组
                  var colorList = [
                    '#F47A25', '#EFE42A', '#64BD3D', '#EE9201', '#29AAE3',
                    '#B74AE5', '#0AAF9F', '#E89589', '#60C0EB', '#5472EC', '#F37126', '#FDB01F', '#4498FA', '#8B55FD', '#B72DFF', '#0BE0A6', '#7BCE4C'
                  ]
                  return colorList[params.dataIndex]
                },
                // 以下为是否显示
                label: {
                  show: false
                }
              }
            }
          }
        ]
      })
    }
  }
}
</script>
